import React from 'react';
import { SiLeetcode } from 'react-icons/si';
import { BsWhatsapp, BsGithub } from 'react-icons/bs';
import { FaHackerrank } from 'react-icons/fa';
import { GrLinkedin } from 'react-icons/gr';
import { HiMail, HiPhone, HiLocationMarker } from 'react-icons/hi';
import emailjs from '@emailjs/browser';
import swal from 'sweetalert';

function Contact() {
    function sendEmail(e) {
        e.preventDefault();
        emailjs.sendForm(
            process.env.REACT_APP_EMAILJS_SERVICE_ID,
            process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
            e.target,
            process.env.REACT_APP_EMAILJS_USER_ID
        ).then(
            (result) => {
                e.target.reset();
                swal({ title: "Thank You!", text: "Message sent successfully!", icon: "success", button: "Ok" });
                console.log(result.text);
            },
            (error) => {
                swal({ title: "Oops!", text: "Something went wrong. Please try again.", icon: "error", button: "Ok" });
                console.log(error.text);
            }
        );
    }

    return (
        <div id="contact" className="min-h-screen flex flex-col bg-gray-900 text-white py-16 px-4 sm:px-12 md:px-24">

            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
                Get In <span className="text-indigo-400">Touch</span>
                <br />
                <span className="w-8 h-1 bg-indigo-500 inline-block rounded-full mt-2" />
            </h2>

            <div className="grid md:grid-cols-2 gap-12 max-w-5xl mx-auto">

                {/* Left — Contact Info + Socials */}
                <div className="flex flex-col gap-8">
                    <div className="flex flex-col gap-5">
                        <a href="mailto:mdazwad22@gmail.com" className="flex items-center gap-4 group">
                            <div className="w-12 h-12 rounded-full bg-indigo-500/10 flex items-center justify-center text-indigo-400 group-hover:bg-indigo-500/20 transition-colors">
                                <HiMail className="w-5 h-5" />
                            </div>
                            <div>
                                <p className="text-xs text-gray-400 font-medium">Email</p>
                                <p className="text-sm font-semibold text-white">mdazwad22@gmail.com</p>
                            </div>
                        </a>

                        <a href="tel:+8801857528424" className="flex items-center gap-4 group">
                            <div className="w-12 h-12 rounded-full bg-indigo-500/10 flex items-center justify-center text-indigo-400 group-hover:bg-indigo-500/20 transition-colors">
                                <HiPhone className="w-5 h-5" />
                            </div>
                            <div>
                                <p className="text-xs text-gray-400 font-medium">Phone</p>
                                <p className="text-sm font-semibold text-white">+880 1857-528424</p>
                            </div>
                        </a>

                        <div className="flex items-center gap-4">
                            <div className="w-12 h-12 rounded-full bg-indigo-500/10 flex items-center justify-center text-indigo-400">
                                <HiLocationMarker className="w-5 h-5" />
                            </div>
                            <div>
                                <p className="text-xs text-gray-400 font-medium">Location</p>
                                <p className="text-sm font-semibold text-white">Bashundhara R/A, Dhaka-1229, Bangladesh</p>
                            </div>
                        </div>
                    </div>

                    {/* Social Links */}
                    <div>
                        <p className="text-xs text-gray-400 font-medium mb-4 uppercase tracking-widest">Find me on</p>
                        <div className="flex gap-3">
                            <a href="https://www.linkedin.com/in/afid-md-azwad-05537a196/" target="_blank" rel="noreferrer"
                                className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gray-400 hover:bg-[#0077B5]/20 hover:text-[#0077B5] transition-all duration-300">
                                <GrLinkedin className="w-4 h-4" />
                            </a>
                            <a href="https://wa.me/8801857528424" target="_blank" rel="noreferrer"
                                className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gray-400 hover:bg-[#25D366]/20 hover:text-[#25D366] transition-all duration-300">
                                <BsWhatsapp className="w-4 h-4" />
                            </a>
                            <a href="https://github.com/AfidAzwad" target="_blank" rel="noreferrer"
                                className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gray-400 hover:bg-[#6e40c9]/20 hover:text-[#6e40c9] transition-all duration-300">
                                <BsGithub className="w-4 h-4" />
                            </a>
                            <a href="https://leetcode.com/u/afidazwad/" target="_blank" rel="noreferrer"
                                className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gray-400 hover:bg-[#FFA116]/20 hover:text-[#FFA116] transition-all duration-300">
                                <SiLeetcode className="w-4 h-4" />
                            </a>
                            <a href="https://www.hackerrank.com/mdazwad22" target="_blank" rel="noreferrer"
                                className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gray-400 hover:bg-[#00EA64]/20 hover:text-[#00EA64] transition-all duration-300">
                                <FaHackerrank className="w-4 h-4" />
                            </a>
                        </div>
                    </div>
                </div>

                {/* Right — Form */}
                <form onSubmit={sendEmail} className="flex flex-col gap-4">
                    <div>
                        <label className="block text-xs font-medium text-gray-400 mb-1.5">Your Email</label>
                        <input
                            type="email"
                            name="email"
                            required
                            placeholder="you@example.com"
                            className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 transition-colors"
                        />
                    </div>
                    <div>
                        <label className="block text-xs font-medium text-gray-400 mb-1.5">Message</label>
                        <textarea
                            name="message"
                            required
                            rows={6}
                            placeholder="Hi Azwad, I'd like to..."
                            className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 transition-colors resize-none"
                        />
                    </div>
                    <button
                        type="submit"
                        className="self-end bg-indigo-600 hover:bg-indigo-700 text-white font-semibold rounded-lg px-8 py-3 text-sm transition-colors duration-300"
                    >
                        Send Message
                    </button>
                </form>
            </div>

            <p className="text-center text-xs text-gray-500 mt-auto pt-16">
                &copy; {new Date().getFullYear()} Afid Md Azwad. All Rights Reserved.
            </p>
        </div>
    );
}

export default Contact;
